import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { NgClass } from '@angular/common';
import { IImageListElementBlok } from './image-list-element.model';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';

@Component({
    selector: 'app-image-list-element',
    imports: [CmsComponent, CmsComponent, NgClass],
    templateUrl: './image-list-element.component.html',
    styleUrl: './image-list-element.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class]': 'getDisplayClasses()',
    },
})
export class ImageListElementComponent {
    private _tailwind = inject(TailwindService);
    block = input.required<IImageListElementBlok>();

    getDisplayClasses = computed<string[]>(() => {
       return this._tailwind.getDisplayClasses(this.block());
    });

    getOuterClasses = computed(() => {
        const block = this.block();
        return [
            ...this._tailwind.getSizeClasses(block),
            ...this._tailwind.getSpacingClasses(block),
        ];
    });
}
